<script setup lang="ts">
import previewIcon from "~/assets/icons/preview/preview.svg"

const { state: previewState } = usePreview()
</script>

<template>
  <dropdown
    v-model:active="previewState.dropdownOpen"
    anchor-x="right"
    anchor-y="bottom"
    flow-x="left"
    flow-y="down"
  >
    <template #default="{ toggle }">
      <nav-pill class="preview-container">
        <nav-pill-button
          class="preview"
          @click="toggle()"
        >
          <preview-icon class="preview-icon" />
          <div class="pr-1">
            Preview
          </div>
        </nav-pill-button>
      </nav-pill>
    </template>
    <template #menu>
      <nav-preview-mode-dropdown class="preview-dropdown" />
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.preview-container
  @apply gap-2
.preview
  @apply p-[#{$pill-m-button}]
.preview-icon
  @apply ml-1
.preview-dropdown
  @apply my-2
</style>
